import logo from "../../../image/logo_dark.svg";
import page_dashboard_background from "../page/PageDashboard/image/background.png";

export default {
  colorPrimary: "#274C5B",
  fontFamily: "Inter, sans-serif",

  page_dashboard__background: "#EDEFEF",
  page_dashboard__hero_background: `url(${page_dashboard_background}) #eef1f3 no-repeat`,
  page_builder__background: `url(${page_dashboard_background}) #eef1f3 no-repeat`,
  logo_src: logo,

  sidebar_background: "#fff",
  sidebar_profile_color: "#274C5B",
  sidebar__width: 200,
};
